import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Container, Grid, GridColumn, Icon, Button } from "semantic-ui-react";
import MobileApplyNow from "./common/MobileApplyNow";
import ApplyNow from "./common/ApplyNow";
import handleApplyEntry from "./common/handleApplyEntry";


class Terms extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  handleApplyClick = () => {
    handleApplyEntry({
      show: this.props.show,
      history: this.props.history,
      openApplySidebar: this.toggleVisibility
    });
  };

  closeMenu = () => this.setState({ visible: false });

  render() {
    const { show, season } = this.props;

    let termsOfUse = require('../assets/pdf/' + process.env.REACT_APP_TERMS);
    let Nutzungsbedingungen = require('../assets/docs/Nutzungsbedingungen.docx');
    let NutzungsbedingungenGs = require('../assets/pdf/NutzungsbedingungenGs.pdf');
    let Teilnahmebedingungen = require('../assets/docs/Teilnahmebedingungen.docx');
    let TeilnahmebedingungenGs = require('../assets/pdf/TeilnahmebedingungenGs.pdf');
    let zu_Informationszwecken = require('../assets/docs/zu Informationszwecken.docx');
    let zu_InformationszweckenGs = require('../assets/pdf/ZuInformationszweckenGs.pdf'); 
    const IsGermanShoreShow = process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';
    const productionPrivacyPolicy = process.env.REACT_APP_PRODUCTION_PRIVACY_POLICY_URL;


    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
              <Button
                onClick={this.toggleVisibility}
                id="applyToggle"
                className="tiny ui primary tablet-down mobileToggle"
              >
                <Icon className="sidebar" />
                {IsGermanShoreShow ? "Bewirb dich jetzt" : "Apply Now"}
              </Button>
            </GridColumn>
          </Grid>

          <MobileApplyNow
            season={season}
            visible={this.state.visible} toggleVisibility={this.toggleVisibility} onApply={this.handleApplyClick} />

          <Grid className="ui stackable" onClick={this.closeMenu}>
            <div className="ui sixteen wide mobile eight wide computer column">
              {IsGermanShoreShow ? (
                <div>
                  <h1>Nutzungsbedingungen</h1>

                  <style>{`
                .inner-html a {
                  color: #${season.hexColorCodeC} !important;
                }
              `}</style>

                  <div
                    className="inner-html"
                    dangerouslySetInnerHTML={{
                      __html: season.termsOfServiceC,
                    }}
                  />

                 <a
                    href={NutzungsbedingungenGs}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                      Nutzungsbedingungen
                    </h2>
                  </a>

                  <a
                    href={TeilnahmebedingungenGs}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                      Teilnahmebedingungen
                    </h2>
                  </a>

                  <a
                    href={zu_InformationszweckenGs}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                      Zu Informationszwecken
                    </h2>
                  </a>
                </div>
              )
                :
                (
                  <div>
                    <h1>Terms of Use</h1>

                    <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                    <div className="inner-html"
                      dangerouslySetInnerHTML={{
                        __html: season.termsOfServiceC,
                      }}
                    />

                    <a
                      href={productionPrivacyPolicy}
                      target="_blank" rel="noopener noreferrer"
                    >
                      <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                        Privacy Policy
                      </h2>
                    </a>
                    <a
                      href={termsOfUse}
                      download
                    >
                      <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                        Terms of Use
                      </h2>
                    </a>

                    <a
                      href='https://www.constantin-entertainment.de/privacy.html'
                      target="_blank" rel="noopener noreferrer"
                    >
                      <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                        Applicant Terms
                      </h2>
                    </a>

                    <Link to="/eligibility">
                      <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                        Eligibility Requirements
                      </h2>
                    </Link>
                  </div>
                )}
            </div>
            <ApplyNow
              season={season}
              onApply={this.handleApplyClick}
            />

          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default withRouter(connect(mapStatesToProps)(Terms));



// WEBPACK FOOTER //
// ./src/components/Terms.js